module.exports = __webpack_public_path__ + "img/border_trapezoid.2e046434.svg";